import XLSX from 'xlsx-js-style'

/**
 * json数据导出excel
 * @param {*} th 表头数据
 * @param {*} data 数据
 * @param {*} fileName 导出excel名称
 * @param {*} mustIdxs 需要必填的表头下标
 */
export const exportJsonToExcel = (th, data, fileName, mustIdxs = []) => {
	const workbook = XLSX.utils.book_new()
	const worksheetData = [th, ...data]
	const worksheet = XLSX.utils.aoa_to_sheet(worksheetData)
	const range = XLSX.utils.decode_range(worksheet['!ref'])
	for (let c = range.s.c; c <= range.e.c; c++) {
		const cellAddress = XLSX.utils.encode_cell({ r: 0, c })
		if (worksheet[cellAddress]) {
			worksheet[cellAddress].s = {
				font: {
					sz: 12,
					bold: false,
					color: { rgb: mustIdxs.includes(c) ? 'FF0000' : null },
				},
				alignment: {
					horizontal: 'left',
					vertical: 'center',
				},
			}
		}
		worksheet['!cols'] = new Array(range.e.c + 1).fill({ wpx: 120 })
	}

	XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

	XLSX.writeFile(workbook, `${fileName}.xlsx`)
}
